<section class="mainTopBanner section-pd documarkBannerForm">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="topBannerWrapper align-items-center">
                    <div class="top-banner-left">
                        <h1 class="trinka-sub-title">DocuMark</h1>
                        <h2 class="text-white">Uphold Academic Integrity. Strengthen Institutional Trust.</h2>
                        <p class="text-white">Empowers universities to manage AI-generated content, prevent cheating, and support student writing through responsible AI use. DocuMark provides transparency in the writing process, keeps humans in the loop, and prioritizes learning outcomes.</p>
                        <div class="btn-group mt-30">
                            <img src="assets/images/gartner.png" width="190" alt="gartner" />
                        </div>
                        <section class="pb-wrap">
                            <div class="pb-card">
                              <div class="pb-top">
                                <div class="pb-show">
                                  <img src="../../../../assets/images/documark-podcast.svg" width="115" alt="documark podcast" />
                                </div>
                              </div>
                       
                              <div class="pb-main">
                                <button type="button" class="pb-play" (click)="toggle()" [attr.aria-label]="isPlaying ? 'Pause episode' : 'Play episode'">
                                  <span class="pb-play-inner">
                                    <svg *ngIf="!isPlaying" width="18" height="18" viewBox="0 0 24 24" fill="#7448a3"><path d="M8 5v14l11-7z"></path></svg>
                                    <svg *ngIf="isPlaying" width="18" height="18" viewBox="0 0 24 24" fill="#7448a3"><rect x="6" y="5" width="4" height="14"></rect><rect x="14" y="5" width="4" height="14"></rect></svg>
                                  </span>
                                </button>
                                <h3 class="pb-title">{{ title }}</h3>
                              </div>
                            </div>
                       
                              <!-- <div class="pb-progress" (click)="seek($event)" role="slider" aria-label="Seek"
                                   [attr.aria-valuemin]="0" [attr.aria-valuemax]="duration" [attr.aria-valuenow]="currentTime">
                                <div class="pb-progress-fill" [style.width.%]="progress"></div>
                              </div>
                              <div class="pb-times">
                                <span>{{ format(currentTime) }}</span>
                                <span>{{ format(duration) }}</span>
                              </div> -->
                              <div class="pd-footer">                                
                                <div class="pb-links">
                                    <a class="pb-btn pb-btn-spotify" [href]="spotifyUrl" target="_blank" rel="noopener noreferrer">
                                    <span class="pb-btn-icon pb-btn-icon-light">
                                        <img src="assets/images/podcast/spotify-icon.png" width="20" alt="documark spotify" />
                                    </span>
                                    Spotify
                                    </a>
                                    <a class="pb-btn pb-btn-youtube" [href]="youtubeUrl" target="_blank" rel="noopener noreferrer">
                                    <span class="pb-btn-icon">
                                        <img src="assets/images/podcast/youtube.png" width="20" alt="documark youtube" />
                                    </span>
                                    YouTube
                                    </a>
                                </div>
                              </div>

                       
                              <audio #audio [src]="audioSrc" preload="metadata"
                                     (loadedmetadata)="onMetadata()"
                                     (timeupdate)="onTimeUpdate()"
                                     (play)="isPlaying = true"
                                     (pause)="isPlaying = false"
                                     (ended)="isPlaying = false"></audio>
                        </section>
                    </div>
                    <div class="top-banner-right" #target>
                        <app-documark-form class="w-100"></app-documark-form>
                        
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="universitiesLogo bg-light-purple">
    <app-global-leaders 
        [title]="'Trusted by Leading Universities Worldwide'"
        [clientLogos]="customLogos"
    >
    </app-global-leaders>
</section>

<section class="section-pd">
    <div class="trinka_container container">
        <div class="row justify-content-center align-items-center">
            <div class="col-md-10">
                <div class="trinka-title text-center mb-30">
                    <h2>Watch How DocuMark Works</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                </div>
            </div>
            <div class="col-md-12">
                <div class="text-center videoBox">
                    <a href="" data-toggle="modal" data-target="#wordPluginPopup">
                        <img src="assets/images/features/documark/documark-yt-thumbnail.webp" alt="documark thumbnail"/>
                    </a>
                </div>
            </div>
            <div class="col-md-12">
                <div class="btn-group mt-30 justify-content-center">
                    <button type="button" (click)="scroll(target)" class="filled-btn">Book A Demo</button>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-pd bg-light-purple">
    <div class="trinka_container">
        <div class="row justify-content-center">
            <div class="col-lg-10 col-md-10">
                <div class="trinka-title text-center">
                    <h2>Who Benefits from DocuMark?</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    <p class="w-100">DocuMark creates value for every stakeholder in the academic ecosystem.It promotes transparency, trust, and better learning outcomes.</p>
                </div>
            </div>
            <div class="col-lg-12 col-md-12">
                <div class="documarkTabs">
                    <ul class="nav nav-pills nav-justified">
                        <li class="nav-item">
                          <a class="nav-link"
                             [class.active]="activeTab === 'Educators'"
                             (click)="setTab('Educators')">
                            Educators
                          </a>
                        </li>
                      
                        <li class="nav-item">
                          <a class="nav-link"
                             [class.active]="activeTab === 'Students'"
                             (click)="setTab('Students')">
                            Students
                          </a>
                        </li>
                      
                        <li class="nav-item">
                          <a class="nav-link"
                             [class.active]="activeTab === 'Administrators'"
                             (click)="setTab('Administrators')">
                            Administrators
                          </a>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="col-12">
                <div class="tab-content w-100">
                    <!-- Educators Tabs -->
                    <div class="tab-pane active" id="Educators">

                        <div class="documarkContent" [ngStyle]="{
                                                    'background-image': 'url(' + tabsData[activeTab]?.bg + ')'
                                                }">
                            <h3>{{ tabsData[activeTab]?.heading }}</h3>
                        
                            <div *ngIf="activeTab" class="glide dmSlider" id="mainSlider">
                                

                                    <div class="glide__track" data-glide-el="track">
                                      <ul class="glide__slides">
                                
                                        <li class="glide__slide"
                                            *ngFor="let card of tabsData[activeTab]?.cards; trackBy: trackByIndex">
                                
                                          <div class="dm-wrapper">
                                            <span [innerHTML]="card.icon"></span>
                                            <h4 [innerHTML]="card.title"></h4>
                                            <p>{{ card.desc }}</p>
                                          </div>
                                
                                        </li>
                                
                                      </ul>
                                    </div>
                        
                                <div class="glide__arrows" data-glide-el="controls">
                                    <button class="glide__arrow glide__arrow--left" data-glide-dir="<">
                                        <svg width="11" height="16" viewBox="0 0 11 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M9.51953 15L1.51953 8L9.51953 1" stroke="#4D4D4D" stroke-width="2" stroke-linecap="round"/>
                                        </svg>
                                            
                                    </button>
                                    <button class="glide__arrow glide__arrow--right" data-glide-dir=">">
                                        <svg width="11" height="16" viewBox="0 0 11 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M0.999999 1L9 8L0.999999 15" stroke="#4D4D4D" stroke-width="2" stroke-linecap="round"/>
                                            </svg>
                                            
                                    </button>
                                </div>
                        
                            </div>
                        
                        </div>

                        <div class="documarkContent d-none" style='background-image: url("../../../../assets/images/features/documark/educators.webp")'>
                            <h3>Helps educators focus on what matters — without adding more work to their plate.</h3>
                            <div class="glide dmSlider" id="">
                                <div class="glide__track" data-glide-el="track">
                                  <ul class="glide__slides">
                                    <li class="glide__slide" *ngFor="let card of educatorsCards">
                                        <div class="dm-wrapper">
                                          
                                            <span [innerHTML]="card.icon"></span>
                                        
                                            <h4>{{ card.title }}</h4>
                                            <p>{{ card.desc }}</p>
                                        
                                        </div>
                                    </li>
                                  </ul>
                                </div>
                                <!-- Navigation -->
                                <!-- <div class="glide__arrows" data-glide-el="controls">
                                    <button class="glide__arrow glide__arrow--left" data-glide-dir="<">
                                        <svg width="32px" height="32px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M10.7672 7.5431C11.0672 7.25744 11.0788 6.78271 10.7931 6.48276C10.5074 6.18281 10.0327 6.17123 9.73276 6.4569L10.7672 7.5431ZM4.48276 11.4569C4.18281 11.7426 4.17123 12.2173 4.4569 12.5172C4.74256 12.8172 5.21729 12.8288 5.51724 12.5431L4.48276 11.4569ZM5.51724 11.4569C5.21729 11.1712 4.74256 11.1828 4.4569 11.4828C4.17123 11.7827 4.18281 12.2574 4.48276 12.5431L5.51724 11.4569ZM9.73276 17.5431C10.0327 17.8288 10.5074 17.8172 10.7931 17.5172C11.0788 17.2173 11.0672 16.7426 10.7672 16.4569L9.73276 17.5431ZM5 11.25C4.58579 11.25 4.25 11.5858 4.25 12C4.25 12.4142 4.58579 12.75 5 12.75V11.25ZM19 12.75C19.4142 12.75 19.75 12.4142 19.75 12C19.75 11.5858 19.4142 11.25 19 11.25V12.75ZM9.73276 6.4569L4.48276 11.4569L5.51724 12.5431L10.7672 7.5431L9.73276 6.4569ZM4.48276 12.5431L9.73276 17.5431L10.7672 16.4569L5.51724 11.4569L4.48276 12.5431ZM5 12.75H19V11.25H5V12.75Z" fill="#000"></path> </g></svg>
                                    </button>
                                    <button class="glide__arrow glide__arrow--right" data-glide-dir=">">
                                        <svg width="32px" height="32px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M13.2328 16.4569C12.9328 16.7426 12.9212 17.2173 13.2069 17.5172C13.4926 17.8172 13.9673 17.8288 14.2672 17.5431L13.2328 16.4569ZM19.5172 12.5431C19.8172 12.2574 19.8288 11.7827 19.5431 11.4828C19.2574 11.1828 18.7827 11.1712 18.4828 11.4569L19.5172 12.5431ZM18.4828 12.5431C18.7827 12.8288 19.2574 12.8172 19.5431 12.5172C19.8288 12.2173 19.8172 11.7426 19.5172 11.4569L18.4828 12.5431ZM14.2672 6.4569C13.9673 6.17123 13.4926 6.18281 13.2069 6.48276C12.9212 6.78271 12.9328 7.25744 13.2328 7.5431L14.2672 6.4569ZM19 12.75C19.4142 12.75 19.75 12.4142 19.75 12C19.75 11.5858 19.4142 11.25 19 11.25V12.75ZM5 11.25C4.58579 11.25 4.25 11.5858 4.25 12C4.25 12.4142 4.58579 12.75 5 12.75V11.25ZM14.2672 17.5431L19.5172 12.5431L18.4828 11.4569L13.2328 16.4569L14.2672 17.5431ZM19.5172 11.4569L14.2672 6.4569L13.2328 7.5431L18.4828 12.5431L19.5172 11.4569ZM19 11.25L5 11.25V12.75L19 12.75V11.25Z" fill="#000"></path> </g></svg>
                                    </button>
                                </div> -->
                            </div>
                        </div>
                    </div>


                </div>
            </div>
            <div class="col-md-12">
                <div class="btn-group mt-30 justify-content-center">
                    <button type="button" (click)="scroll(target)" class="filled-btn">Get Started</button>
                </div>
            </div>
        </div>
    </div>
</section>

<section id="osu"><app-osusection></app-osusection></section>

<section class="section-pd pb-40 position-relative grammarCheckerWithoutInternet list-wrapper-style-2">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-md-12 col-lg-8">
                <div class="trinka-title mb-0 text-center text-white">
                    <h2 class="text-white">Easy to Get Started</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    <p class="text-white w-100">No IT hardware or additional software investment. <br class="d-sm-block d-none"/>Works within your existing tools and platforms.</p>
                </div>
            </div>
        </div>
        <div class="row match-box">
            <div class="col-lg-4 col-md-6 dflex">
                <div class="list-wrapper-content-2 list-style-cards pr-0 bt-none text-center">
                    <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M53.3333 40C53.3333 44.9707 53.3333 47.456 52.5227 49.4133C51.9866 50.7076 51.2008 51.8837 50.2103 52.8743C49.2197 53.8649 48.0436 54.6506 46.7493 55.1867C44.7893 56 42.304 56 37.3333 56H29.3333C19.2747 56 14.2453 56 11.12 52.8747C8 49.752 8 44.7227 8 34.6667V18.6667C8 15.8377 9.12381 13.1246 11.1242 11.1242C13.1246 9.12381 15.8377 8 18.6667 8" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M26.667 22.6666L27.8243 33.2506C27.8735 33.6845 28.0352 34.0981 28.2934 34.4503C28.5516 34.8025 28.8973 35.0811 29.2963 35.2586C31.1257 36.0453 34.5523 37.3333 37.3337 37.3333C40.115 37.3333 43.5417 36.0453 45.371 35.2586C45.7705 35.0815 46.1168 34.803 46.3754 34.4508C46.6341 34.0986 46.7962 33.6848 46.8457 33.2506L48.0003 22.6666M54.667 20V30.0533M37.3337 10.6666L18.667 18.6666L37.3337 26.6666L56.0003 18.6666L37.3337 10.6666Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg> 
                    <h3 class="text-white">Course-level</h3>
                    <p class="text-white">Start small with one class or semester. See results before committing further.</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 dflex">
                <div class="list-wrapper-content-2 list-style-cards pr-0 middle-card text-center">
                    <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M26.667 32H37.3337M26.667 21.3334H37.3337M37.3337 56V48C37.3337 46.5856 36.7718 45.229 35.7716 44.2288C34.7714 43.2286 33.4148 42.6667 32.0003 42.6667C30.5858 42.6667 29.2293 43.2286 28.2291 44.2288C27.2289 45.229 26.667 46.5856 26.667 48V56" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M15.9997 26.6666H10.6663C9.25185 26.6666 7.8953 27.2285 6.8951 28.2287C5.89491 29.2289 5.33301 30.5855 5.33301 32V50.6666C5.33301 52.0811 5.89491 53.4377 6.8951 54.4379C7.8953 55.4381 9.25185 56 10.6663 56H53.333C54.7475 56 56.104 55.4381 57.1042 54.4379C58.1044 53.4377 58.6663 52.0811 58.6663 50.6666V24C58.6663 22.5855 58.1044 21.2289 57.1042 20.2287C56.104 19.2285 54.7475 18.6666 53.333 18.6666H47.9997" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M16 56V13.3333C16 11.9188 16.5619 10.5623 17.5621 9.5621C18.5623 8.5619 19.9188 8 21.3333 8H42.6667C44.0812 8 45.4377 8.5619 46.4379 9.5621C47.4381 10.5623 48 11.9188 48 13.3333V56" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <h3 class="text-white">Department-level</h3>
                    <p class="text-white">Expand across your faculty or department. Build the case for scale.</p>
                    
                </div>
            </div>
            <div class="col-lg-4 col-md-6 dflex">
                <div class="list-wrapper-content-2 list-style-cards pr-0 bt-none text-center">
                    <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M58.6663 22.6666V35.9999M37.9117 9.33327C36.0642 8.45631 34.0447 8.00134 31.9997 8.00134C29.9546 8.00134 27.9352 8.45631 26.0877 9.33327L8.24501 17.6986C4.36234 19.5173 4.36234 25.8159 8.24501 27.6346L26.085 35.9999C27.9329 36.8773 29.9528 37.3325 31.9983 37.3325C34.0439 37.3325 36.0638 36.8773 37.9117 35.9999L55.7543 27.6346C59.637 25.8159 59.637 19.5173 55.7543 17.6986L37.9117 9.33327Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M13.333 30.6666V44.3333C13.333 52.1146 25.8503 56 31.9997 56C38.149 56 50.6663 52.1146 50.6663 44.3333V30.6666" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <h3 class="text-white">University-wide</h3>
                    <p class="text-white">Full institutional rollout with centralized policy dashboard & analytics.</p>
                    
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-pd-sm text-center bg-light-purple complianceCertificates">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-12 col-md-12">
                <div class="trinka-title text-center">
                    <h3>Data Privacy and Security Assured</h3>
                    <p class="text-center w-100 mt-3">Student data is never used to train AI models. <br class="d-sm-block d-none"/>No screen recording, browser history tracking, or cookie-based surveillance. <br class="d-sm-block d-none"/>All data remains secure, private, and institution-controlled.</p>
                </div>
            </div>
            <div class="col-lg-12 col-md-12">
                <ul>
                    <li>
                        <img src="assets/images/enterprise/confidential-data/compliance-certificates/hippa.png" alt="hippa" />
                    </li>
                    <li>
                        <img src="assets/images/enterprise/confidential-data/compliance-certificates/AICPA_SOC.png" alt="AICPA" />
                    </li>
                    <li>
                        <img src="assets/images/enterprise/confidential-data/compliance-certificates/information-security-management-system.svg" alt="iso" />
                    </li>
                    <li>
                        <img src="assets/images/enterprise/confidential-data/compliance-certificates/ferpa.png" alt="ferpa" />
                    </li>
                    <li>
                        <img src="assets/images/enterprise/confidential-data/compliance-certificates/eu-ai-act.png" alt="eu ai act" />
                    </li>
                    <li>
                        <img src="assets/images/enterprise/confidential-data/compliance-certificates/gdpr.svg" alt="GDPR" />
                    </li>
                    <li>
                        <img src="assets/images/enterprise/confidential-data/compliance-certificates/quality-management-system.svg" alt="iso" />
                    </li>
                    <li>
                        <img src="assets/images/enterprise/confidential-data/compliance-certificates/translation-service-requirements.svg" alt="iso" />
                    </li>
                    <li>
                        <img src="assets/images/enterprise/confidential-data/compliance-certificates/ada.png" alt="ada" />
                    </li>
                </ul>
            </div>
        </div>
    </div>
</section>

<section class="section-pd">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-md-12 col-lg-11">
                <div class="trinka-title mb-0 text-center">
                    <h2>How Does DocuMark Differ from AI Detection Tools?</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    <p class="w-100">Unlike AI detection tools that predict AI use, DocuMark provides transparent insights into student effort, AI usage, and ownership throughout the writing process.</p>
                </div>
            </div>
        </div>
        <div class="row justify-content-center match-box">
            <div class="col-md-6 col-lg-6 col-sm-6 dflex">
                <div class="trinka-comparison trinkaFt c-card">
                    <h4>
                        <span class="icon">
                            <svg width="44" height="60" viewBox="0 0 44 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_3237_157)">
                                <path d="M22.8008 6.20508C23.8869 6.20527 24.9293 6.63639 25.6973 7.4043L38.1768 19.8828L38.3379 20.0518C39.1221 20.9181 39.5599 22.0476 39.5605 23.2217V44.8643C39.5605 45.9506 39.1284 46.9926 38.3604 47.7607C37.592 48.5289 36.5502 48.9609 35.4639 48.9609H16.6035V46.71H35.4639C35.9533 46.7099 36.4223 46.515 36.7686 46.1689C37.1146 45.8228 37.3096 45.3538 37.3096 44.8643V23.7578H25.3809C24.4856 23.7578 23.6262 23.4035 22.9932 22.7705C22.3601 22.1373 22.0049 21.278 22.0049 20.3828V8.45508H8.0957C7.60646 8.45521 7.13603 8.6501 6.79004 8.99609C6.44408 9.34216 6.25004 9.81242 6.25 10.3018V10.3037L6.42676 24.5537C5.63984 24.7147 4.88481 24.9655 4.1748 25.2969L4 10.3018C4.00004 9.21543 4.43113 8.17246 5.19922 7.4043C5.96741 6.63644 7.00964 6.2052 8.0957 6.20508H22.8008ZM39.0068 47.3359C38.9038 47.4837 38.7918 47.6259 38.6699 47.7607C38.7918 47.6259 38.9037 47.4837 39.0068 47.3359ZM35.8955 46.4238C35.8648 46.4323 35.834 46.4406 35.8027 46.4473C35.834 46.4406 35.8648 46.4323 35.8955 46.4238ZM36.2158 46.2988C36.1343 46.3415 36.0494 46.377 35.9619 46.4053C36.0494 46.377 36.1343 46.3415 36.2158 46.2988ZM36.333 46.2305C36.3046 46.2485 36.2755 46.265 36.2461 46.2812C36.2755 46.265 36.3046 46.2485 36.333 46.2305ZM36.457 46.1426C36.4318 46.1622 36.4062 46.1812 36.3799 46.1992C36.4062 46.1812 36.4318 46.1622 36.457 46.1426ZM36.7178 45.8916C36.684 45.9328 36.6484 45.9727 36.6104 46.0107L36.5576 46.0576C36.5747 46.0419 36.5929 46.0272 36.6094 46.0107L36.7178 45.8916ZM3.9541 25.6562C4.05512 25.6047 4.15679 25.554 4.25977 25.5059C4.1568 25.5541 4.05512 25.6047 3.9541 25.6562ZM4.58984 25.3594C4.69243 25.3159 4.79609 25.2745 4.90039 25.2344C4.7961 25.2745 4.69242 25.3158 4.58984 25.3594ZM4.9707 25.208C5.03686 25.1831 5.10311 25.1583 5.16992 25.1348C5.10312 25.1583 5.03685 25.1831 4.9707 25.208ZM5.3457 25.0742C5.38682 25.0606 5.42837 25.0482 5.46973 25.0352C5.42838 25.0483 5.38682 25.0606 5.3457 25.0742ZM5.65527 24.9775C5.70198 24.9638 5.74891 24.9506 5.7959 24.9375C5.74891 24.9506 5.70198 24.9638 5.65527 24.9775ZM25.2129 23.9795L25.3809 23.9834L25.2021 23.9795C25.1646 23.9776 25.1272 23.9737 25.0898 23.9707C25.1308 23.974 25.1717 23.9776 25.2129 23.9795ZM6.50684 9.98438C6.48614 10.0881 6.47559 10.1945 6.47559 10.3018L6.64355 23.7725L6.47461 10.3018C6.47462 10.1944 6.48608 10.0882 6.50684 9.98438ZM24.2549 20.3828C24.2549 20.6812 24.374 20.9677 24.585 21.1787C24.796 21.3897 25.0825 21.5088 25.3809 21.5088H36.6191L36.2354 21.124L24.2549 9.14551V20.3828ZM25.1494 21.251C25.1442 21.2496 25.139 21.2485 25.1338 21.2471C25.139 21.2485 25.1442 21.2496 25.1494 21.251ZM25.002 21.1982C24.9973 21.1961 24.9929 21.1936 24.9883 21.1914C24.9929 21.1936 24.9973 21.1961 25.002 21.1982ZM24.8691 21.1221C24.8628 21.1177 24.8568 21.1129 24.8506 21.1084C24.8568 21.1129 24.8628 21.1177 24.8691 21.1221ZM24.6533 20.9102C24.649 20.9041 24.6439 20.8987 24.6396 20.8926C24.6439 20.8987 24.649 20.9041 24.6533 20.9102ZM24.5713 20.7744C24.5691 20.7698 24.5666 20.7654 24.5645 20.7607C24.5666 20.7654 24.5691 20.7698 24.5713 20.7744ZM24.5156 20.6289C24.5142 20.6237 24.5131 20.6185 24.5117 20.6133C24.5131 20.6185 24.5142 20.6237 24.5156 20.6289ZM6.9502 9.15527C6.98473 9.12076 7.02042 9.08768 7.05762 9.05664C7.02042 9.08766 6.98473 9.12076 6.9502 9.15527ZM7.11621 9.01172C7.13662 8.99621 7.15667 8.98031 7.17773 8.96582C7.15667 8.9803 7.13662 8.99622 7.11621 9.01172ZM7.23242 8.93066C7.26024 8.91313 7.28861 8.89664 7.31738 8.88086C7.2886 8.89662 7.26024 8.91314 7.23242 8.93066ZM7.35059 8.86328C7.38579 8.84502 7.42159 8.82812 7.45801 8.8125C7.42159 8.8281 7.3858 8.84504 7.35059 8.86328ZM7.49121 8.79883C7.52695 8.78443 7.56291 8.77061 7.59961 8.75879C7.56291 8.77059 7.52695 8.78445 7.49121 8.79883ZM7.93555 8.68848C7.83253 8.69871 7.73112 8.71875 7.63281 8.74805C7.68699 8.73187 7.74207 8.71845 7.79785 8.70801L7.93555 8.68848ZM4.76172 7.55273C4.69461 7.63414 4.63102 7.71802 4.57031 7.80371C4.6285 7.72158 4.68885 7.64071 4.75293 7.5625L4.76172 7.55273ZM25.1982 6.70605C25.2569 6.74514 25.3143 6.7861 25.3711 6.82812C25.2575 6.74411 25.1402 6.66595 25.0195 6.59375L25.1982 6.70605ZM7.68262 6C7.64637 6.00348 7.6103 6.00831 7.57422 6.0127C7.60578 6.00886 7.63726 6.00412 7.66895 6.00098L7.68262 6ZM4.30957 25.4834C4.40223 25.4407 4.49568 25.3993 4.58984 25.3594C4.49569 25.3993 4.40223 25.4406 4.30957 25.4834ZM21.8047 20.7969C21.8086 20.8304 21.8116 20.8641 21.8164 20.8975C21.8116 20.8641 21.8086 20.8304 21.8047 20.7969ZM21.8584 21.126C21.8537 21.1035 21.8481 21.0812 21.8438 21.0586C21.8481 21.0812 21.8537 21.1035 21.8584 21.126Z" fill="#763393"/>
                                <path d="M28.6988 38.5985H21.1176C20.4959 38.5985 19.9805 38.0895 19.9805 37.4758C19.9805 36.8619 20.4959 36.353 21.1176 36.353H28.6988C29.3205 36.353 29.836 36.8619 29.836 37.4758C29.836 38.0895 29.3205 38.5985 28.6988 38.5985Z" fill="#763393"/>
                                <path d="M33.2475 31.8658H21.1176C20.4959 31.8658 19.9805 31.3535 19.9805 30.7354C19.9805 30.1175 20.4959 29.605 21.1176 29.605H33.2475C33.8691 29.605 34.3848 30.1175 34.3848 30.7354C34.3848 31.3535 33.8691 31.8658 33.2475 31.8658Z" fill="#763393"/>
                                <path d="M6.47869 27.787C4.68733 28.1936 3.08764 29.1976 1.9424 30.6337C0.797168 32.0698 0.174513 33.8528 0.176764 35.6896C0.175582 36.7539 0.384341 37.8081 0.79111 38.7916C1.19786 39.7753 1.79465 40.6689 2.54726 41.4215C3.29987 42.174 4.19352 41.3029 5.17707 41.7096C6.16074 42.1164 7.21476 42.3252 8.27909 42.3239C9.41995 42.3245 10.5481 42.0842 11.5895 41.6186C12.631 41.153 13.5623 41.9409 14.3228 41.0904C15.0832 40.2401 15.6555 39.2388 16.0022 38.1519C16.3488 37.0651 16.3346 34.7835 16.3346 34.7835C16.3346 34.7835 15.8414 32.556 15.262 31.5735C14.6823 30.5907 13.9018 29.7416 12.9714 29.0815C12.041 28.4214 10.9818 27.9652 9.86283 27.7427C8.74391 27.5202 7.59067 27.5366 6.47869 27.7907M6.41566 48.8532L8.28096 47.3948L12.5428 50.7313C12.7291 50.8772 12.9527 50.968 13.1881 50.993C13.4235 51.0177 13.6612 50.9759 13.8739 50.872C14.0866 50.7681 14.2657 50.6064 14.3908 50.4055C14.5158 50.2044 14.5818 49.9721 14.5811 49.7356L14.5811 41.2309C12.8086 42.6976 11.0266 42.9688 8.72609 42.9662C8.14628 42.9651 7.40009 43.0611 6.85029 42.9662C5.15549 42.6749 3.30135 42.328 1.9773 41.2309L1.9773 49.7356C1.97756 49.9718 2.04422 50.2032 2.1697 50.4034C2.29515 50.6035 2.47437 50.7645 2.68686 50.8677C2.89937 50.971 3.1366 51.0125 3.37153 50.9873C3.60645 50.9622 3.8296 50.8716 4.01549 50.7258L6.41566 48.8532Z" fill="#16A34A"/>
                                <path d="M5.5791 36.7362L6.87716 38.034L10.1223 34.7891" stroke="#6E00A1" stroke-width="1.43812" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M16.5318 36.0983C16.4861 36.5066 16.3728 36.9056 16.1948 37.278L16.1929 37.2763C15.9573 37.7706 15.5776 38.1949 15.3265 38.4888L15.2495 38.5749C15.2467 38.6068 15.2443 38.6434 15.2404 38.6905C15.2098 39.0801 15.1828 39.6496 15.0004 40.165L14.9986 40.1632C14.8612 40.552 14.6609 40.914 14.4051 41.2348L14.1321 41.5426L13.8243 41.8155C13.6103 41.9864 13.3784 42.1339 13.1319 42.2534L12.7528 42.4109L12.751 42.4126C12.2593 42.5859 11.736 42.6171 11.3844 42.6454L11.2927 42.6527L11.28 42.6527C11.2338 42.6563 11.1974 42.6593 11.1663 42.6619C11.1455 42.6794 11.1215 42.7004 11.0913 42.7259L11.0747 42.7388L11.0656 42.748C10.7772 42.9934 10.3567 43.3715 9.86935 43.6053L9.86766 43.6071C9.37114 43.8444 8.82771 43.9678 8.27754 43.9678C7.72736 43.9678 7.18395 43.8442 6.68761 43.6071L6.68929 43.6053C6.19708 43.3704 5.77184 42.9894 5.48221 42.7424L5.47658 42.7369L5.45651 42.7186L5.43457 42.7004C5.41975 42.687 5.40399 42.6745 5.3888 42.6619C5.35766 42.6593 5.32127 42.6563 5.27512 42.6527L5.26049 42.6527C4.88195 42.6223 4.31358 42.5925 3.80055 42.4109C3.28245 42.2275 2.81144 41.9313 2.42296 41.5426C2.03579 41.1551 1.74166 40.6848 1.5584 40.1688C1.37382 39.6514 1.34474 39.0795 1.31473 38.6959L1.31286 38.6978C1.30892 38.649 1.30835 38.6111 1.30554 38.5787C1.29278 38.5635 1.28041 38.5475 1.26709 38.5329L1.24702 38.5109L1.22676 38.4871C0.975959 38.1922 0.594986 37.7707 0.360323 37.2817L0.360323 37.2798C0.123033 36.7837 -0.000397114 36.2399 -0.000584011 35.6899C-0.000583987 35.1411 0.122467 34.5988 0.358444 34.1035C0.594044 33.6078 0.9769 33.1835 1.22863 32.889L1.24702 32.867L1.26521 32.8468C1.27872 32.8319 1.29091 32.8147 1.30366 32.7991C1.30554 32.7796 1.30817 32.7601 1.30929 32.7406L1.31286 32.6856C1.34343 32.2959 1.37232 31.7282 1.55465 31.2128C1.73773 30.6949 2.03467 30.2238 2.42296 29.8353C2.81163 29.4464 3.28227 29.1485 3.80055 28.9651C4.31359 28.7836 4.88195 28.7554 5.26049 28.7252L5.27156 28.7252L5.30082 28.7215L5.33196 28.7197C5.35222 28.7187 5.37229 28.716 5.39236 28.7142L5.46383 28.6519L5.48034 28.6372L5.48221 28.6391L5.48953 28.6299C5.77784 28.3845 6.19839 28.0063 6.68573 27.7726L6.68761 27.7708C7.05996 27.5927 7.45894 27.4794 7.8673 27.4337L8.27754 27.4099L8.68797 27.4337C9.09614 27.4795 9.49513 27.5927 9.86766 27.7708L9.86935 27.7726C10.3591 28.0076 10.7808 28.3868 11.0766 28.6391L11.0913 28.6519C11.1215 28.6775 11.1455 28.6983 11.1663 28.716C11.1974 28.7186 11.2338 28.7197 11.28 28.7233L11.2835 28.7252L11.2927 28.7252C11.6731 28.7556 12.2385 28.7845 12.751 28.9651C13.2696 29.1487 13.7433 29.4478 14.1321 29.8371L14.4069 30.143C14.662 30.4632 14.8616 30.825 14.9986 31.2128C15.1809 31.7279 15.2116 32.2959 15.2422 32.6856C15.246 32.7318 15.2469 32.7678 15.2495 32.7991C15.2696 32.8227 15.2929 32.8503 15.3229 32.8852L15.3283 32.8908C15.5791 33.1855 15.9584 33.6072 16.1929 34.096L16.1948 34.0979C16.4322 34.5943 16.5557 35.1379 16.5557 35.688L16.5318 36.0983Z" fill="#16A34A" stroke="#16A34A" stroke-width="0.787839"/>
                                <path d="M6.17578 35.6419L7.54362 37.0096L10.9628 33.5903" stroke="white" stroke-width="1.43812" stroke-linecap="round" stroke-linejoin="round"/>
                                </g>
                                <defs>
                                <clipPath id="clip0_3237_157">
                                <rect width="44" height="60" fill="white"/>
                                </clipPath>
                                </defs>
                            </svg>
                        </span>
                        DocuMark 
                    </h4>
                    <div class="comparisonContent">
                        <div class="media">
                            <div class="media-left">
                                <span>
                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="9" cy="9" r="8.25" stroke="#16A34A" stroke-width="1.5"/>
                                        <path d="M12.9287 6.29932L7.5274 11.7006L5.07227 9.24548" stroke="#16A34A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                        
                                </span>
                            </div>
                            <div class="media-body">
                                <p>Focuses on learning and responsible AI use</p>
                            </div>
                        </div>
                        <div class="media">
                            <div class="media-left">
                                <span>
                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="9" cy="9" r="8.25" stroke="#16A34A" stroke-width="1.5"/>
                                        <path d="M12.9287 6.29932L7.5274 11.7006L5.07227 9.24548" stroke="#16A34A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                        
                                </span>
                            </div>
                            <div class="media-body">
                                <p>Provides writing process transparency reports, disclosing AI use</p>
                            </div>
                        </div>
                        <div class="media">
                            <div class="media-left">
                                <span>
                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="9" cy="9" r="8.25" stroke="#16A34A" stroke-width="1.5"/>
                                        <path d="M12.9287 6.29932L7.5274 11.7006L5.07227 9.24548" stroke="#16A34A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                        
                                </span>
                            </div>
                            <div class="media-body">
                                <p>High accuracy through proactive writing process documentation</p>
                            </div>
                        </div>
                        <div class="media">
                            <div class="media-left">
                                <span>
                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="9" cy="9" r="8.25" stroke="#16A34A" stroke-width="1.5"/>
                                        <path d="M12.9287 6.29932L7.5274 11.7006L5.07227 9.24548" stroke="#16A34A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                        
                                </span>
                            </div>
                            <div class="media-body">
                                <p>Responsibility lies with students</p>
                            </div>
                        </div>
                        <div class="media">
                            <div class="media-left">
                                <span>
                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="9" cy="9" r="8.25" stroke="#16A34A" stroke-width="1.5"/>
                                        <path d="M12.9287 6.29932L7.5274 11.7006L5.07227 9.24548" stroke="#16A34A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                        
                                </span>
                            </div>
                            <div class="media-body">
                                <p>Reinforces authentic writing and prevents cognitive off-loading</p>
                            </div>
                        </div>
                        <div class="media">
                            <div class="media-left">
                                <span>
                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="9" cy="9" r="8.25" stroke="#16A34A" stroke-width="1.5"/>
                                        <path d="M12.9287 6.29932L7.5274 11.7006L5.07227 9.24548" stroke="#16A34A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                        
                                </span>
                            </div>
                            <div class="media-body">
                                <p>Keep your data private and does not use it for AI Training</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-6 col-lg-6 col-sm-6 dflex">
                <div class="trinka-comparison othersFt c-card">
                    <h4>
                        <span class="icon">
                            <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M20 7.5H15.5C12.6997 7.5 11.2996 7.5 10.23 8.04497C9.28924 8.52433 8.52433 9.28924 8.04497 10.23C7.5 11.2996 7.5 12.6997 7.5 15.5V20M20 52.5H15.5C12.6997 52.5 11.2996 52.5 10.23 51.955C9.28924 51.4757 8.52433 50.7108 8.04497 49.77C7.5 48.7004 7.5 47.3003 7.5 44.5V40M52.5 20V15.5C52.5 12.6997 52.5 11.2996 51.955 10.23C51.4757 9.28924 50.7108 8.52433 49.77 8.04497C48.7004 7.5 47.3003 7.5 44.5 7.5H40M52.5 40V44.5C52.5 47.3003 52.5 48.7004 51.955 49.77C51.4757 50.7108 50.7108 51.4757 49.77 51.955C48.7004 52.5 47.3003 52.5 44.5 52.5H40" stroke="#FF5C5C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                <rect x="14.2334" y="13.9233" width="31.5332" height="32.1533" rx="4" stroke="#FF5C5C" stroke-width="2"/>
                                <line x1="20.2676" y1="20.8611" x2="39.707" y2="20.8611" stroke="#FF5C5C" stroke-width="2" stroke-linecap="round"/>
                                <line x1="20.2676" y1="27.2317" x2="36.3369" y2="27.2317" stroke="#FF5C5C" stroke-width="2" stroke-linecap="round"/>
                                <line x1="19.6621" y1="33.1472" x2="39.707" y2="33.1472" stroke="#FF5C5C" stroke-width="2" stroke-linecap="round"/>
                                <line x1="19.6621" y1="39.1389" x2="32.3369" y2="39.1389" stroke="#FF5C5C" stroke-width="2" stroke-linecap="round"/>
                            </svg>
                        </span>
                        AI Detectors 
                    </h4>
                    <div class="comparisonContent">
                        <div class="media">
                            <div class="media-left">
                                <span>
                                    <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M3.66464 7.58025C6.23236 3.02646 7.51622 0.75 9.54981 0.75C11.5834 0.75 12.8673 3.02646 15.435 7.58025L15.7553 8.14694C17.8892 11.9308 18.9566 13.8227 17.9921 15.206C17.0277 16.5893 14.6413 16.5893 9.87011 16.5893H9.2295C4.45836 16.5893 2.07191 16.5893 1.10748 15.206C0.143039 13.8227 1.21043 11.9308 3.34433 8.14694L3.66464 7.58025Z" stroke="#FF5C5C" stroke-width="1.5"/>
                                        <path d="M9.5498 5.14917V9.54897" stroke="#FF5C5C" stroke-width="1.5" stroke-linecap="round"/>
                                        <path d="M9.42976 13.1906C9.91575 13.1906 10.3097 12.7966 10.3097 12.3106C10.3097 11.8246 9.91575 11.4307 9.42976 11.4307C8.94378 11.4307 8.5498 11.8246 8.5498 12.3106C8.5498 12.7966 8.94378 13.1906 9.42976 13.1906Z" fill="#FF5C5C"/>
                                    </svg>
                                </span>
                            </div>
                            <div class="media-body">
                                <p>Focuses on AI policing and enforcement</p>
                            </div>
                        </div>
                        <div class="media">
                            <div class="media-left">
                                <span>
                                    <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M3.66464 7.58025C6.23236 3.02646 7.51622 0.75 9.54981 0.75C11.5834 0.75 12.8673 3.02646 15.435 7.58025L15.7553 8.14694C17.8892 11.9308 18.9566 13.8227 17.9921 15.206C17.0277 16.5893 14.6413 16.5893 9.87011 16.5893H9.2295C4.45836 16.5893 2.07191 16.5893 1.10748 15.206C0.143039 13.8227 1.21043 11.9308 3.34433 8.14694L3.66464 7.58025Z" stroke="#FF5C5C" stroke-width="1.5"/>
                                        <path d="M9.5498 5.14917V9.54897" stroke="#FF5C5C" stroke-width="1.5" stroke-linecap="round"/>
                                        <path d="M9.42976 13.1906C9.91575 13.1906 10.3097 12.7966 10.3097 12.3106C10.3097 11.8246 9.91575 11.4307 9.42976 11.4307C8.94378 11.4307 8.5498 11.8246 8.5498 12.3106C8.5498 12.7966 8.94378 13.1906 9.42976 13.1906Z" fill="#FF5C5C"/>
                                    </svg>
                                </span>
                            </div>
                            <div class="media-body">
                                <p>Provides AI detection scores based on probability</p>
                            </div>
                        </div>
                        <div class="media">
                            <div class="media-left">
                                <span>
                                    <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M3.66464 7.58025C6.23236 3.02646 7.51622 0.75 9.54981 0.75C11.5834 0.75 12.8673 3.02646 15.435 7.58025L15.7553 8.14694C17.8892 11.9308 18.9566 13.8227 17.9921 15.206C17.0277 16.5893 14.6413 16.5893 9.87011 16.5893H9.2295C4.45836 16.5893 2.07191 16.5893 1.10748 15.206C0.143039 13.8227 1.21043 11.9308 3.34433 8.14694L3.66464 7.58025Z" stroke="#FF5C5C" stroke-width="1.5"/>
                                        <path d="M9.5498 5.14917V9.54897" stroke="#FF5C5C" stroke-width="1.5" stroke-linecap="round"/>
                                        <path d="M9.42976 13.1906C9.91575 13.1906 10.3097 12.7966 10.3097 12.3106C10.3097 11.8246 9.91575 11.4307 9.42976 11.4307C8.94378 11.4307 8.5498 11.8246 8.5498 12.3106C8.5498 12.7966 8.94378 13.1906 9.42976 13.1906Z" fill="#FF5C5C"/>
                                    </svg>
                                </span>
                            </div>
                            <div class="media-body">
                                <p>Reactive detection with low accuracy and high false positives</p>
                            </div>
                        </div>
                        <div class="media">
                            <div class="media-left">
                                <span>
                                    <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M3.66464 7.58025C6.23236 3.02646 7.51622 0.75 9.54981 0.75C11.5834 0.75 12.8673 3.02646 15.435 7.58025L15.7553 8.14694C17.8892 11.9308 18.9566 13.8227 17.9921 15.206C17.0277 16.5893 14.6413 16.5893 9.87011 16.5893H9.2295C4.45836 16.5893 2.07191 16.5893 1.10748 15.206C0.143039 13.8227 1.21043 11.9308 3.34433 8.14694L3.66464 7.58025Z" stroke="#FF5C5C" stroke-width="1.5"/>
                                        <path d="M9.5498 5.14917V9.54897" stroke="#FF5C5C" stroke-width="1.5" stroke-linecap="round"/>
                                        <path d="M9.42976 13.1906C9.91575 13.1906 10.3097 12.7966 10.3097 12.3106C10.3097 11.8246 9.91575 11.4307 9.42976 11.4307C8.94378 11.4307 8.5498 11.8246 8.5498 12.3106C8.5498 12.7966 8.94378 13.1906 9.42976 13.1906Z" fill="#FF5C5C"/>
                                    </svg>
                                </span>
                            </div>
                            <div class="media-body">
                                <p>Responsibility often lies with faculty</p>
                            </div>
                        </div>
                        <div class="media">
                            <div class="media-left">
                                <span>
                                    <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M3.66464 7.58025C6.23236 3.02646 7.51622 0.75 9.54981 0.75C11.5834 0.75 12.8673 3.02646 15.435 7.58025L15.7553 8.14694C17.8892 11.9308 18.9566 13.8227 17.9921 15.206C17.0277 16.5893 14.6413 16.5893 9.87011 16.5893H9.2295C4.45836 16.5893 2.07191 16.5893 1.10748 15.206C0.143039 13.8227 1.21043 11.9308 3.34433 8.14694L3.66464 7.58025Z" stroke="#FF5C5C" stroke-width="1.5"/>
                                        <path d="M9.5498 5.14917V9.54897" stroke="#FF5C5C" stroke-width="1.5" stroke-linecap="round"/>
                                        <path d="M9.42976 13.1906C9.91575 13.1906 10.3097 12.7966 10.3097 12.3106C10.3097 11.8246 9.91575 11.4307 9.42976 11.4307C8.94378 11.4307 8.5498 11.8246 8.5498 12.3106C8.5498 12.7966 8.94378 13.1906 9.42976 13.1906Z" fill="#FF5C5C"/>
                                    </svg>
                                </span>
                            </div>
                            <div class="media-body">
                                <p>Cannot assess the depth of a student's cognitive engagement</p>
                            </div>
                        </div>
                        <div class="media">
                            <div class="media-left">
                                <span>
                                    <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M3.66464 7.58025C6.23236 3.02646 7.51622 0.75 9.54981 0.75C11.5834 0.75 12.8673 3.02646 15.435 7.58025L15.7553 8.14694C17.8892 11.9308 18.9566 13.8227 17.9921 15.206C17.0277 16.5893 14.6413 16.5893 9.87011 16.5893H9.2295C4.45836 16.5893 2.07191 16.5893 1.10748 15.206C0.143039 13.8227 1.21043 11.9308 3.34433 8.14694L3.66464 7.58025Z" stroke="#FF5C5C" stroke-width="1.5"/>
                                        <path d="M9.5498 5.14917V9.54897" stroke="#FF5C5C" stroke-width="1.5" stroke-linecap="round"/>
                                        <path d="M9.42976 13.1906C9.91575 13.1906 10.3097 12.7966 10.3097 12.3106C10.3097 11.8246 9.91575 11.4307 9.42976 11.4307C8.94378 11.4307 8.5498 11.8246 8.5498 12.3106C8.5498 12.7966 8.94378 13.1906 9.42976 13.1906Z" fill="#FF5C5C"/>
                                    </svg>
                                </span>
                            </div>
                            <div class="media-body">
                                <p>May not be secure and may use your data for AI Training</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="btn-group justify-content-center mt-40">
                    <button type="button" (click)="scroll(target)" class="filled-btn">Request a Pilot</button>
                </div>
            </div>
        </div>
    </div>
</section>

<app-whitepaper-section></app-whitepaper-section>

<section class="section-pd bg-light-purple">
    <app-testimonial [testimonials]="customTestimonials"></app-testimonial>
</section>

<section class="section-pd">
    <div class="trinka_container container">
        <div class="row match-box justify-content-center">
            <div class="col-lg-8 col-md-10">
                <div class="trinka-title mb-0 text-center">
                    <h2>Apps and Integrations</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                </div>
            </div>
        </div>
        <div class="ins-bg">
            <span class="shape">
                <svg width="1301" height="759" viewBox="0 0 1301 759" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g filter="url(#filter0_f_104_913)">
                    <ellipse cx="650.061" cy="379.061" rx="488.5" ry="217.5" fill="#AD7FF9"/>
                    </g>
                    <defs>
                    <filter id="filter0_f_104_913" x="-9.15527e-05" y="-9.15527e-05" width="1300.12" height="758.121" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
                    <feGaussianBlur stdDeviation="80.7803" result="effect1_foregroundBlur_104_913"/>
                    </filter>
                    </defs>
                </svg> 
            </span>
            <div class="row match-box">
                <div class="col-sm-6 dflex">
                    <div class="integritySolution c-card">
                        <h4 class="text-center">Works with</h4>
                        <div class="text-center">
                            <img src="assets/images/enterprise/academic-institution/grammar-checker-works-with.svg"  alt="integrity-solution" class="img-fluid" />
                        </div>
                        <small>and more...</small>
                    </div>
                </div>
                <div class="col-sm-6 dflex">
                    <div class="integritySolution c-card">
                        <h4 class="text-center">LMS Integrations</h4>
                        <div class="text-center mt-4">
                            <img src="assets/images/enterprise/academic-institution/lms-integration.webp" alt="LMS Integrations" class="img-fluid" />
                        </div>
                        <small>and more...</small>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>


<section class="section-pd bg-light-purple">
    <div class="trinka_container container">
        <div class="row match-box justify-content-center">
            <div class="col-lg-8 col-md-10">
                <div class="trinka-title mb-0 text-center">
                    <h2>Industry Engagements</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                </div>
            </div>
        </div>
        <div class="row match-box justify-content-center">
            <div class="col-sm-4 dflex">
                <div class="institutionsCard c-card">
                    <div class="ins-image">
                        <img src="assets/images/features/documark/remaining-academic-integrity.png" alt="poster" />
                        <span>Report</span>
                    </div>
                    <div class="ins-content">
                        <h6>An Experts’ Report on Academic Integrity in the AI Era</h6>
                        <a [routerLink]="['/industry-engagements/expert-report-on-trends-in-the-age-of-ai']" class="text-link">
                            Read the Report
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M8 6L12 10L8 14" stroke="#0000FF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg> 
                        </a>
                    </div>
                </div>
            </div>
            <div class="col-sm-4 dflex">
                <div class="institutionsCard c-card">
                    <div class="ins-image">
                        <img src="assets/images/industry-engagements/poster1.png" alt="poster" />
                        <span>Conference Poster</span>
                    </div>
                    <div class="ins-content">
                        <h6>Beyond Detection: Restoring Confidence in Academic Integrity in the Age of AI</h6>
                        <a [routerLink]="['/industry-engagements/beyond-detection-academic-integrity-in-the-age-of-ai']" class="text-link">
                            Read the Poster
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M8 6L12 10L8 14" stroke="#0000FF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg> 
                        </a>
                    </div>
                </div>
            </div>
            <div class="col-sm-4 dflex">
                <div class="institutionsCard c-card">
                    <div class="ins-image">
                        <img src="assets/images/features/documark/presentation.png" alt="poster" />
                        <span>Presentation</span>
                    </div>
                    <div class="ins-content">
                        <h6>Shaping the Future of Learning: Proactive Strategies for Addressing the Ethical Challenges of AI Use in Higher Education</h6>
                        <a [routerLink]="['/industry-engagements/shaping-future-of-learning-ethical-ai-in-higher-education']" class="text-link">
                            Read the Presentation
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M8 6L12 10L8 14" stroke="#0000FF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg> 
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="btn-group justify-content-center mt-40">
                    <a [routerLink]="['/industry-engagements']" class="filled-btn">
                        Explore All 20+ Engagements
                        <svg width="19" height="15" viewBox="0 0 19 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 6.36377C0.447715 6.36377 4.82823e-08 6.81148 0 7.36377C-4.82823e-08 7.91605 0.447715 8.36377 1 8.36377L1 7.36377L1 6.36377ZM18.7071 8.07088C19.0976 7.68035 19.0976 7.04719 18.7071 6.65666L12.3431 0.292703C11.9526 -0.0978217 11.3195 -0.0978218 10.9289 0.292703C10.5384 0.683227 10.5384 1.31639 10.9289 1.70692L16.5858 7.36377L10.9289 13.0206C10.5384 13.4111 10.5384 14.0443 10.9289 14.4348C11.3195 14.8254 11.9526 14.8254 12.3431 14.4348L18.7071 8.07088ZM1 7.36377L1 8.36377L18 8.36377L18 7.36377L18 6.36377L1 6.36377L1 7.36377Z" fill="white"/>
                        </svg> 
                    </a>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="trinka-banner section-pd-sm">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-md-12 col-lg-10">
                <div class="trinka-title text-center mb-40">
                    <h2 class="mb-4 text-white">
                        Ready to Shift from AI Detection to Learning Outcomes?
                    </h2>
                </div>
                <div class="btn-group justify-content-center">
                    <button type="button" (click)="scroll(target)" class="white-btn" target="_blank">Talk to Our Experts</button>
                </div>
            </div>
        </div>  
    </div>
</section>

<section class="faqQuestionAnwser section-pd">
    <div class="trinka_container">
        <div class="row justify-content-center">
            <div class="col-lg-8 col-md-10">
                <div class="trinka-title text-center">
                    <h2>Frequently Asked Questions</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                </div>
            </div>
        </div>
        <div class="faqQuestionsList">
            <div class="accordion" id="faq">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="faqContainer">
                            <div class="card">
                                <div class="card-header" id="QuestionOne">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionOneContent" aria-expanded="true" aria-controls="QuestionOneContent">
                                        What is DocuMark and how does it support academic integrity?
                                    </a>
                                </div>

                                <div id="QuestionOneContent" class="collapse" aria-labelledby="QuestionOne" data-parent="#faq">
                                    <div class="card-body">
                                        <p>DocuMark is an academic integrity solution that helps educators shift from AI detection to learning outcomes. It provides transparency into AI usage, encourages responsible AI use, and helps maintain trust between students and faculty.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-header" id="QuestionTwo">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionTwoContent" aria-expanded="true"
                                        aria-controls="QuestionTwoContent">How does DocuMark provide visibility into AI assisted writing?</a>
                                </div>

                                <div id="QuestionTwoContent" class="collapse" aria-labelledby="QuestionTwo" data-parent="#faq">
                                    <div class="card-body">
                                        <p>DocuMark provides transparency into the writing process by capturing revisions, student contributions, and declared AI usage. This helps educators better understand how a document was created without relying on AI detection.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-header" id="QuestionFour">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionFourContent" aria-expanded="true"
                                        aria-controls="QuestionFourContent">
                                        Who can use DocuMark?
                                    </a>
                                </div>

                                <div id="QuestionFourContent" class="collapse" aria-labelledby="QuestionFour" data-parent="#faq">
                                    <div class="card-body">
                                        <p>DocuMark is designed for instructors, faculty, academic administrators, and assessment teams. It helps institutions uphold academic integrity while enabling students to demonstrate their writing process and ownership.</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionSix">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionSixContent" aria-expanded="true"
                                        aria-controls="QuestionSixContent">
                                        Can DocuMark identify when students use AI tools?
                                    </a>
                                </div>

                                <div id="QuestionSixContent" class="collapse" aria-labelledby="QuestionSix" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Yes. DocuMark provides visibility into how AI is used during the writing process, giving educators a clearer understanding of student contributions and AI involvement.</p>
                                    </div>
                                </div>
                            </div>


                            <div class="card">
                                <div class="card-header" id="QuestionThree">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionThreeContent" aria-expanded="true"
                                        aria-controls="QuestionThreeContent">
                                        Why is DocuMark better than AI detectors?
                                    </a>
                                </div>

                                <div id="QuestionThreeContent" class="collapse" aria-labelledby="QuestionThree" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Traditional AI detection tools often rely on predictions that can be inaccurate. DocuMark takes a transparency first approach by helping students review, verify, and take ownership of their AI use, providing educators with more meaningful insights.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="faqContainer">

                            <div class="card">
                                <div class="card-header" id="QuestionFive">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionFiveContent" aria-expanded="true"
                                        aria-controls="QuestionFiveContent">
                                       How can DocuMark help institutions create responsible AI policies?
                                    </a>
                                </div>

                                <div id="QuestionFiveContent" class="collapse" aria-labelledby="QuestionFive" data-parent="#faq">
                                    <div class="card-body">
                                        <p>DocuMark provides data and insights that help institutions develop policies for responsible AI use. Institutions can also leverage our AI literacy and Responsible AI Policy resources to guide faculty and students: <a href="https://www.trinka.ai/university-ai-policy-repository" class="text-link" target="_blank">www.trinka.ai/university-ai-policy-repository</a></p>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-header" id="QuestionSeven">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionSevenContent" aria-expanded="true"
                                        aria-controls="QuestionSevenContent">
                                        Can students or researchers demonstrate their original work with DocuMark?
                                    </a>
                                </div>

                                <div id="QuestionSevenContent" class="collapse" aria-labelledby="QuestionSeven" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Yes. DocuMark helps students and researchers demonstrate their effort, review process, and ownership of AI assisted work, promoting responsibility and academic integrity.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-header" id="QuestionEight">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionEightContent" aria-expanded="true"
                                        aria-controls="QuestionEightContent">
                                        Can DocuMark be integrated with an institution's existing LMS system?
                                    </a>
                                </div>

                                <div id="QuestionEightContent" class="collapse" aria-labelledby="QuestionEight" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Yes. DocuMark integrates seamlessly with commonly used academic tools and Learning Management Systems (LMS), ensuring easy adoption without disrupting your existing workflows.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-header" id="QuestionNine">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionNineContent" aria-expanded="true"
                                        aria-controls="QuestionNineContent">
                                       What platforms does DocuMark work on?
                                    </a>
                                </div>

                                <div id="QuestionNineContent" class="collapse" aria-labelledby="QuestionNine" data-parent="#faq">
                                    <div class="card-body">
                                        <p>DocuMark works on Trinka Cloud, MS Word, and Google Docs. It can also be easily integrated into the institute’s existing LMS systems.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-header" id="QuestionTen">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionTenContent" aria-expanded="true"
                                        aria-controls="QuestionTenContent">
                                       How do instructors use DocuMark insights to grade fairly and consistently?
                                    </a>
                                </div>

                                <div id="QuestionTenContent" class="collapse" aria-labelledby="QuestionTen" data-parent="#faq">
                                    <div class="card-body">
                                        <p>DocuMark provides effort scores, ownership scores, and revision insights that help instructors better understand student contributions and support fair, consistent assessment practices.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>


<div class="modal fade" id="wordPluginPopup" tabindex="-1" role="dialog" aria-labelledby="wordPluginLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-body" style="padding: 0;">
                <button type="button" id="closedPopup" class="close" data-dismiss="modal" aria-label="Close" (click)="stopAllVideos()">
                    <span aria-hidden="true">&times;</span>
                </button>
                <div id="iframeHolder"></div>

                <iframe id="youtubeVideoForTryDemo" width="100%" height="450" src="https://www.youtube.com/embed/AkdtJdPE1bk?si=81Y5Uiknl9fHBHs_" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </div>
        </div>
    </div>
</div>

<!-- <div *ngIf="isMobile">
    <elevenlabs-convai
      [attr.agent-id]="environment.elevenLabsAgentId">
    </elevenlabs-convai>
</div> -->

<!-- <elevenlabs-convai
  [attr.agent-id]="environment.elevenLabsAgentId"
  variant="compact"
  
  avatar-orb-color-1="#2792dc"
  avatar-orb-color-2="#9ce6e6"
  
  action-text="Need assistance?"
  start-call-text="Begin conversation"
  end-call-text="End call"
  listening-text="Listening..."
  speaking-text="Assistant speaking">
</elevenlabs-convai> -->

<app-trinka-voice-assistant [agentId]="environment.elevenLabsAgentIdDocuMark"></app-trinka-voice-assistant>